import { useMemo } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

export const useUnsubscribeConfig = () => {
    const translate = useTranslations();
    const { timePeriods, unsubscribeReasons: { reasons = [] } } = useComponentConfig();

    return useMemo(() => ({
        availablePeriods: Object.keys(timePeriods).filter(key => timePeriods[key]),
        reasons: [...new Set(reasons.map(reason => translate(reason.value)))]
    }), [timePeriods, reasons, translate]);
};
